(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillar-showcase"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.PillarShows){ window.PillarShows.initAll(); return; }
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var API = {
    initAll:function(){
      document.querySelectorAll('.pillar-slideshow:not([data-pillar-ready])').forEach(API.init);
    },
    init:function(show){
      show.setAttribute('data-pillar-ready','1');
      var slides = Array.prototype.slice.call(show.querySelectorAll('.slide'));
      var dotsWrap = show.querySelector('.pillar-dots');
      if (dotsWrap){ dotsWrap.innerHTML = ''; }
      if (slides.length <= 1){ if (dotsWrap) dotsWrap.style.display = 'none'; return; }

      var current = slides.findIndex(function(s){ return s.classList.contains('active'); });
      if (current < 0){ current = 0; slides[0].classList.add('active'); }

      var dots = slides.map(function(_, i){
        var d = document.createElement('span');
        d.className = 'pillar-dot' + (i === current ? ' active' : '');
        dotsWrap.appendChild(d);
        return d;
      });

      function showIndex(i){
        slides[current].classList.remove('active');
        dots[current].classList.remove('active');
        current = (i + slides.length) % slides.length;
        slides[current].classList.add('active');
        dots[current].classList.add('active');
      }

      var speed = parseInt(show.getAttribute('data-speed') || '0', 10);
      var timer = null;
      function start(){ if (REDUCED || !speed || timer) return; timer = setInterval(function(){ showIndex(current + 1); }, speed); }
      function stop(){ if (timer){ clearInterval(timer); timer = null; } }

      var card = show.closest('.pillar-card') || show;
      card.addEventListener('mouseenter', stop);
      card.addEventListener('mouseleave', start);

      if ('IntersectionObserver' in window){
        new IntersectionObserver(function(entries){
          entries.forEach(function(e){ e.isIntersecting ? start() : stop(); });
        }, { threshold: 0.25 }).observe(show);
      } else { start(); }
    }
  };
  window.PillarShows = API;
  if (document.readyState !== 'loading'){ API.initAll(); }
  document.addEventListener('DOMContentLoaded', API.initAll);
  document.addEventListener('shopify:section:load', API.initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-portfolio-projects"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.PFCarousel){ window.PFCarousel.initAll(); return; }
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PF = {
    initAll:function(){
      document.querySelectorAll('[data-pf-carousel]:not([data-pf-ready])').forEach(PF.init);
    },
    init:function(el){
      el.setAttribute('data-pf-ready','1');
      var track = el.querySelector('.pf-carousel__track');
      var slides = Array.prototype.slice.call(track.children);
      var prev = el.querySelector('.pf-carousel__nav--prev');
      var next = el.querySelector('.pf-carousel__nav--next');
      var dotsWrap = el.querySelector('.pf-carousel__dots');
      var counter = el.querySelector('.pf-carousel__count');
      var counterNum = el.querySelector('.pf-carousel__count-num');

      if (slides.length <= 1){
        if(prev) prev.style.display='none';
        if(next) next.style.display='none';
        if(counter) counter.style.display='none';
        return;
      }

      slides.forEach(function(s, i){
        var b = document.createElement('button');
        b.className = 'pf-carousel__dot'; b.type = 'button';
        b.setAttribute('aria-label', 'Go to image ' + (i+1));
        b.addEventListener('click', function(){ go(i, true); });
        dotsWrap.appendChild(b);
      });
      var dots = Array.prototype.slice.call(dotsWrap.children);
      var current = 0;

      function indexFromScroll(){ return Math.round(track.scrollLeft / track.clientWidth); }
      function go(i, user){
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        if (user) restart();
      }
      function update(){
        current = indexFromScroll();
        dots.forEach(function(d, di){ d.setAttribute('aria-current', di === current ? 'true' : 'false'); });
        if (counterNum){ counterNum.textContent = (current + 1) + ' / ' + slides.length; }
      }
      prev.addEventListener('click', function(){ go(current - 1, true); });
      next.addEventListener('click', function(){ go(current + 1, true); });
      track.addEventListener('scroll', function(){ window.requestAnimationFrame(update); }, { passive:true });
      update();

      /* autoplay */
      var DELAY = parseInt(el.getAttribute('data-pf-autoplay') || '0', 10);
      var timer = null;
      function tick(){ go((indexFromScroll() + 1) % slides.length, false); }
      function start(){ if (REDUCED || !DELAY || timer) return; timer = setInterval(tick, DELAY); }
      function stop(){ if (timer){ clearInterval(timer); timer = null; } }
      function restart(){ stop(); start(); }

      if (DELAY && !REDUCED){
        el.addEventListener('mouseenter', stop);
        el.addEventListener('mouseleave', start);
        el.addEventListener('focusin', stop);
        el.addEventListener('focusout', start);
        track.addEventListener('pointerdown', stop);
        track.addEventListener('pointerup', function(){ setTimeout(start, 600); });
        if ('IntersectionObserver' in window){
          new IntersectionObserver(function(entries){
            entries.forEach(function(e){ e.isIntersecting ? start() : stop(); });
          }, { threshold: 0.3 }).observe(el);
        } else { start(); }
      }
    }
  };
  window.PFCarousel = PF;
  if (document.readyState !== 'loading'){ PF.initAll(); }
  document.addEventListener('DOMContentLoaded', PF.initAll);
  document.addEventListener('shopify:section:load', PF.initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-portfolio-types"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.PFCarousel){ window.PFCarousel.initAll(); return; }
  var PF = {
    initAll:function(){
      document.querySelectorAll('[data-pf-carousel]:not([data-pf-ready])').forEach(PF.init);
    },
    init:function(el){
      el.setAttribute('data-pf-ready','1');
      var track = el.querySelector('.pf-carousel__track');
      var slides = Array.prototype.slice.call(track.children);
      var prev = el.querySelector('.pf-carousel__nav--prev');
      var next = el.querySelector('.pf-carousel__nav--next');
      var dotsWrap = el.querySelector('.pf-carousel__dots');
      if (slides.length <= 1){
        if(prev) prev.style.display='none';
        if(next) next.style.display='none';
        return;
      }
      slides.forEach(function(s, i){
        var b = document.createElement('button');
        b.className = 'pf-carousel__dot'; b.type = 'button';
        b.setAttribute('aria-label', 'Go to image ' + (i+1));
        b.addEventListener('click', function(){ track.scrollTo({ left: track.clientWidth * i, behavior:'smooth' }); });
        dotsWrap.appendChild(b);
      });
      var dots = Array.prototype.slice.call(dotsWrap.children);
      function update(){
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function(d, di){ d.setAttribute('aria-current', di === i ? 'true' : 'false'); });
        prev.disabled = i <= 0;
        next.disabled = i >= slides.length - 1;
      }
      prev.addEventListener('click', function(){ track.scrollBy({ left: -track.clientWidth, behavior:'smooth' }); });
      next.addEventListener('click', function(){ track.scrollBy({ left: track.clientWidth, behavior:'smooth' }); });
      track.addEventListener('scroll', function(){ window.requestAnimationFrame(update); }, { passive:true });
      update();
    }
  };
  window.PFCarousel = PF;
  if (document.readyState !== 'loading'){ PF.initAll(); }
  document.addEventListener('DOMContentLoaded', PF.initAll);
  document.addEventListener('shopify:section:load', PF.initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
